export default "__VITE_ASSET__Czg5qETe__"